import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  getColumnKey,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { RoleComponent } from '@web/shared/module/auth';
import { UserCollectionItem } from '../../models/user-collection-item';
import { UserCollectionFilter } from '../../models/user-collection-filter';
import { UserStatusComponent } from '../../containers/user-status/user-status.component';
import { AccountTypeComponent } from '../../containers/account-type/account-type.component';

@Component({
  selector: 'app-user-list-custom-cell-template',
  imports: [
    RoleComponent,
    TableBodyNoReferenceCellComponent,
    UserStatusComponent,
    AccountTypeComponent,
  ],
  templateUrl: './user-list-custom-cell-template.component.html',
  styleUrl: './user-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<UserCollectionItem, UserCollectionFilter>>();
  public readonly model = input.required<UserCollectionItem>();

  protected readonly getColumnKey = getColumnKey<UserCollectionItem>;
}
